import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { auditService } from '@/services/audit.service'
import { dlqService } from '@/services/dlq.service'
import type { UUID } from '@/types/database'

const KEYS = {
    audit: ['audit_logs'] as const,
    dlq: ['dlq_items'] as const,
}

export function useAuditLogs(filters?: { user_id?: UUID; entidade?: string }) {
    return useQuery({
        queryKey: [...KEYS.audit, filters],
        queryFn: () => auditService.list(filters)
    })
}

export function useDlqItems() {
    return useQuery({
        queryKey: KEYS.dlq,
        queryFn: () => dlqService.list()
    })
}

export function useRetryDlq() {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: (id: UUID) => dlqService.retry(id),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: KEYS.dlq })
    })
}

export function useDiscardDlq() {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: (id: UUID) => dlqService.discard(id),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: KEYS.dlq })
    })
}
